// common translations for the app, used in multiple places

/* HOW TO USE:

import commonMessages from './localization/shared/common' // import common locale messages

export default {
  name: 'SomeComponent',
  template: `
    <div class="">
      Stuff goes here
    </div>
  `,
  i18n: {
    messages: { ... },
    sharedMessages: commonMessages
  }
}
*/

// ! IMPORTANT -- on frontend the keys here also define our 'supported' locales (kinda) -- so you should add things here anytime you add a language
// you should also find a way to make this part of the backend translations machinery....
// ! IMPORTANT -- this is not consistently available yet.... because we are not yet consistently loading VueI18n on all pages... need that first

export default {
  en: {
    buttons: {
      save: "Save",
      cancel: "Cancel",
      close: "Close",
      back: "Back",
      confirm: "Confirm",
    }
  },
  es: {
    buttons: {
      save: "Guardar",
      cancel: "Cancelar",
      close: "Cerrar",
      back: "Atrás",
      confirm: "Confirmar",
    }
  },
  pt: {
    buttons: {
      save: "Salvar",
      cancel: "Cancelar",
      close: "Fechar",
      back: "Voltar",
      confirm: "Confirmar",
    }
  },
  da: {
    buttons: {
      save: "Gem",
      cancel: "Annuller",
      close: "Luk",
      back: "Tilbage",
      confirm: "Bekræft",
    }
  },
  fr: {
    buttons: {
      save: "Enregistrer",
      cancel: "Annuler",
      close: "Fermer",
      back: "Retour",
      confirm: "Confirmer",
    }
  },
  de: {
    buttons: {
      save: "Speichern",
      cancel: "Abbrechen",
      close: "Schließen",
      back: "Zurück",
      confirm: "Bestätigen",
    }
  },
  it: {
    buttons: {
      save: "Salva",
      cancel: "Annulla",
      close: "Chiudi",
      back: "Indietro",
      confirm: "Conferma",
    }
  },
  nl: {
    buttons: {
      save: "Opslaan",
      cancel: "Annuleren",
      close: "Sluiten",
      back: "Terug",
      confirm: "Bevestigen",
    }
  },
  sv: {
    buttons: {
      save: "Spara",
      cancel: "Avbryt",
      close: "Stäng",
      back: "Tillbaka",
      confirm: "Bekräfta",
    }
  },
  fi: {
    buttons: {
      save: "Tallenna",
      cancel: "Peruuta",
      close: "Sulje",
      back: "Takaisin",
      confirm: "Vahvista",
    }
  },
  no: {
    buttons: {
      save: "Lagre",
      cancel: "Avbryt",
      close: "Lukk",
      back: "Tilbake",
      confirm: "Bekreft",
    }
  },
  pl: {
    buttons: {
      save: "Zapisz",
      cancel: "Anuluj",
      close: "Zamknij",
      back: "Wróć",
      confirm: "Potwierdź",
    }
  },
  zh: {
    buttons: {
      save: "保存",
      cancel: "取消",
      close: "关闭",
      back: "返回",
      confirm: "确认",
    }
  },
  'zh-Hans': {
    buttons: {
      save: "保存",
      cancel: "取消",
      close: "关闭",
      back: "返回",
      confirm: "确认",
    }
  },
  'zh-Hant': {
    buttons: {
      save: "儲存",
      cancel: "取消",
      close: "關閉",
      back: "返回",
      confirm: "確認",
    }
  },
  ko: {
    buttons: {
      save: "저장",
      cancel: "취소",
      close: "닫기",
      back: "뒤로",
      confirm: "확인",
    }
  },
  ja: {
    buttons: {
      save: "保存",
      cancel: "キャンセル",
      close: "閉じる",
      back: "戻る",
      confirm: "確認",
    }
  }
}